import React from 'react';
import PropTypes from 'prop-types';
import classes from './CustomFormRadio.module.scss';

const CustomFormRadio = (props) => {
    const { inputData, formik } = props;
    if (!inputData?.is_active) return null;

    return (
        <div className={classes.CustomFormRadio}>
            {inputData?.label ? 
                (<label>
                    {inputData?.label}
                    {inputData?.is_required ? <span className='required'>*</span> : null}
                </label>) 
            : null}
            <div className={classes.RadioOptionsWrap}>
                {inputData?.input_value?.map((option, index) => {
                    return (
                        <div key={`${inputData?.input_id}-${index}`} className={classes.RadioOption}>
                            <input
                                type="radio"
                                name={inputData?.input_name}
                                id={`${inputData?.input_id}-${index}`}
                                value={option?.value}
                                onChange={formik.handleChange}
                                checked={formik?.values?.[inputData?.input_name] === option?.value}
                            />
                            <label htmlFor={`${inputData?.input_id}-${index}`}>
                                {option?.label}
                            </label>
                        </div>
                    )
                })}
            </div>
            {inputData?.helper_text ? (
                <span className='helper-text'>{inputData?.helper_text}</span>
            ) : null}
            {formik.touched[inputData?.input_name] && formik.errors[inputData?.input_name] ? (
                <span className="form-error">{formik.errors[inputData?.input_name]}</span>
            ) : null}
        </div>
    )
}

CustomFormRadio.propTypes = {}

export default CustomFormRadio;